const m = require('minthril');
const { component } = require('../../component');

const Field = component(() => {
  return {
    view: ({ attrs: { label, help, value, type = 'text', min, step, placeholder, onchange } }) => m('label.field',
      m('span', label),
      m(`input[type=${type}]`, { value, min, step, placeholder, onchange }),
      help && m('small.field__help', help)
    )
  };
});

module.exports = { Field };
